import { getBisacCodes, searchBisac } from "reedy-data/api";
import { BaseApi } from "./base";

export class BisacApi extends BaseApi {
  async getCodes() {
    const response = await this.request(getBisacCodes, {});
    return response?.data;
  }

  async search(query: string) {
    const response = await this.request(searchBisac, {
      query: { q: query },
    });
    return response?.data;
  }
}
